module.exports = __webpack_public_path__ + "img/20.b1504f50.jpg";